import { createSchema, ZodOutputFor } from "@opstel/query/zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { Location_Junction } from "@opstel/gen/knop/ui/v1/model/location_pb";
import { z } from "zod/v3";
import { pointSchema } from "@opstel/query/models/point";
import { Point } from "@opstel/geo/Point";

export interface Junction {
  code: string;
  coordinate: Point;
  connectionPermanent: string;
  connectionLeft: string;
  connectionRight: string;
}

export const junctionSchema = createSchema<Junction, PlainMessage<Location_Junction>>({
  code: z.string().min(1, "Junction code should not be empty"),
  coordinate: pointSchema,
  connectionPermanent: z.string().min(1, "Junction connectionPermanent should not be empty"),
  connectionLeft: z.string().min(1, "Junction connectionLeft should not be empty"),
  connectionRight: z.string().min(1, "Junction connectionRight should not be empty"),
}) satisfies ZodOutputFor<Junction>;
